function handleResize() {
    // 既存のリスナーを解除
    removePreviousListeners();

    if (window.innerWidth <= 959) {
        initMobileMenu();
    } else {
        initDesktopMenu();
    }
}

// 既存のイベントリスナーや状態をリセット
function removePreviousListeners() {
    const humOpenBlock = document.querySelector('.hum_open_block');
    const headerContent = document.querySelector('.header_content');
    const headerOverlay = document.querySelector('.header_overlay');
    const closeBtn = document.querySelector('.hum_close_block');
    const returnBtn = document.querySelector('.return_btn');
    const layerMenus = document.querySelectorAll('.layer_menu');
    const menuLinks = document.querySelectorAll('.have_second_layer a');
    const body = document.body;

    // モバイルメニュー関連のクラスとリスナーを解除
    if (headerContent) headerContent.classList.remove('is_opened');
    if (body) body.classList.remove('hum_opened');
    if (returnBtn) returnBtn.style.display = 'none';

    layerMenus.forEach(menu => menu.classList.remove('active'));

    // イベントリスナーを削除
    if (humOpenBlock) humOpenBlock.replaceWith(humOpenBlock.cloneNode(true));
    if (headerOverlay) headerOverlay.replaceWith(headerOverlay.cloneNode(true));
    if (closeBtn) closeBtn.replaceWith(closeBtn.cloneNode(true));
    if (returnBtn) returnBtn.replaceWith(returnBtn.cloneNode(true));
    menuLinks.forEach(link => link.replaceWith(link.cloneNode(true)));

    // デスクトップメニュー関連のクラスを解除
    const menuItems = document.querySelectorAll('.have_second_layer');
    menuItems.forEach(item => {
        const link = item.querySelector('a');
        const dataNum = link ? link.getAttribute('data-num') : null;
        const targetMenu = dataNum
            ? document.querySelector(`.layer_menu[data-num="${dataNum}"]`)
            : null;

        if (targetMenu) targetMenu.classList.remove('active');
    });

    // `details`要素の`open`属性を解除
    document.querySelectorAll('.menu_item details').forEach(details => {
        details.removeAttribute('open');
    });
}

// モバイルメニュー初期化
function initMobileMenu() {
    const humOpenBlock = document.querySelector('.hum_open_block');
    const headerContent = document.querySelector('.header_content');
    const headerOverlay = document.querySelector('.header_overlay');
    const closeBtn = document.querySelector('.hum_close_block');
    const returnBtn = document.querySelector('.return_btn');
    const layerMenus = document.querySelectorAll('.layer_menu');
    const menuLinks = document.querySelectorAll('.have_second_layer a');
    const body = document.body;

    function closeMenus() {
        layerMenus.forEach(menu => menu.classList.remove('active'));
        if (returnBtn) returnBtn.style.display = 'none';
    }

    if (humOpenBlock) {
        humOpenBlock.addEventListener('click', () => {
            headerContent.classList.add('is_opened');
            body.classList.add('hum_opened');
        });
    }

    [headerOverlay, closeBtn].forEach(element => {
        if (element) {
            element.addEventListener('click', () => {
                headerContent.classList.remove('is_opened');
                body.classList.remove('hum_opened');
                closeMenus();
            });
        }
    });

    menuLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const dataNum = this.getAttribute('data-num');
            const targetMenu = document.querySelector(`.layer_menu[data-num="${dataNum}"]`);

            if (targetMenu) {
                layerMenus.forEach(menu => menu.classList.remove('active'));
                targetMenu.classList.add('active');
            }

            if (returnBtn) returnBtn.style.display = 'flex';
        });
    });

    if (returnBtn) {
        returnBtn.addEventListener('click', (e) => {
            e.preventDefault();
            closeMenus();
        });
    }

    if (headerOverlay) {
        headerOverlay.addEventListener('click', closeMenus);
    }
}

// デスクトップメニュー初期化
function initDesktopMenu() {
    const menuItems = document.querySelectorAll('.have_second_layer');

    menuItems.forEach(item => {
        const link = item.querySelector('a');
        const dataNum = link.getAttribute('data-num');
        const targetMenu = document.querySelector(`.layer_menu[data-num="${dataNum}"]`);

        if (!targetMenu) return;

        const deactivateAllMenus = () => {
            document.querySelectorAll('.layer_menu.active').forEach(menu => {
                menu.classList.remove('active');
            });
        };

        const handleMouseEnter = () => {
            deactivateAllMenus();
            targetMenu.classList.add('active');
        };

        const handleMouseLeave = (event) => {
            if (item.contains(event.relatedTarget) || targetMenu.contains(event.relatedTarget)) {
                return;
            }
            targetMenu.classList.remove('active');
        };

        link.addEventListener('mouseenter', handleMouseEnter);
        link.addEventListener('mouseleave', handleMouseLeave);
        targetMenu.addEventListener('mouseenter', handleMouseEnter);
        targetMenu.addEventListener('mouseleave', handleMouseLeave);
    });

    document.querySelectorAll('.menu_item details').forEach(details => {
        details.setAttribute('open', '');
    });
}

// 初回ロード時の画面幅に応じた処理
handleResize();

// リサイズ時のイベントリスナーを追加
window.addEventListener('resize', handleResize);

//サーチボタン・アカウントボタンのmodal
document.addEventListener('DOMContentLoaded', () => {
    const searchIcon = document.querySelector('.aw-header__top__left__search-icon');
    const accountIcon = document.querySelector('.aw-header__top__icon-nav__item a[href="/account"]');
    const searchMenu = document.querySelector('.aw-header__menu[data-menu="2"]');
    const accountMenu = document.querySelector('.aw-header__menu[data-menu="3"]');

    // 他のメニューを閉じる関数
    const closeOtherMenu = (currentMenu) => {
        const menus = [searchMenu, accountMenu]; // 管理するすべてのメニュー
        menus.forEach(menu => {
            if (menu !== currentMenu && menu.classList.contains('is-active')) {
                menu.classList.remove('is-active');
            }
        });
    };

    // クリックイベントのトグル関数
    const toggleActiveClass = (icon, menu) => {
        icon.addEventListener('click', (event) => {
            event.preventDefault(); // デフォルトの動作を防ぐ（必要に応じて）
            closeOtherMenu(menu); // 他のモーダルを閉じる
            menu.classList.toggle('is-active'); // 現在のモーダルをトグル
        });
    };

    // クリックイベントを登録
    if (searchIcon && searchMenu) {
        toggleActiveClass(searchIcon, searchMenu);
    }
    if (accountIcon && accountMenu) {
        toggleActiveClass(accountIcon, accountMenu);
    }
});


